module.exports = __webpack_public_path__ + "media/bell1.dd82e1b8.mp3";